<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card no-border">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-3">
                                        <span v-if="questions.name.passed"
                                            >{{ $t('common.name') }}: {{ selectedName }}</span
                                        ><br />
                                        <span v-if="questions.course.passed"
                                            >{{ $t('group.course') }}: {{ selectedCourse.text }}</span
                                        ><br />
                                        <span v-if="questions.season.passed"
                                            >{{ $t('group.school_year') }}: {{ selectedSeason.text }}</span
                                        ><br />
                                        <span v-if="questions.start.passed">
                                            Start: {{ selectedStart }} {{ questions.startTime }} </span
                                        ><br />
                                        <span v-if="questions.end.passed">{{ $t('group.end') }}: {{ selectedEnd }}</span
                                        ><br />
                                    </div>

                                    <div class="offset-md-3 col-md-5">
                                        <div v-if="questions.name.live">
                                            <label for="group-create-name-input">{{ $t('common.name') }}</label>
                                            <b-form-input
                                                id="group-create-name-input"
                                                v-model="questions.name.value"
                                                style="margin-top: 20px"></b-form-input>
                                            <b-form-invalid-feedback :state="this.valid">
                                                {{ $t('group.please_enter_a_name_before_you_go_further') }}
                                            </b-form-invalid-feedback>
                                        </div>

                                        <div v-if="questions.parent.live">
                                            <label for="group-create-parent-select">{{ $t('group.main_group') }}</label>
                                            <p>
                                                <i>{{
                                                    $t('group.click_next_if_you_do_not_want_to_select_a_main_project')
                                                }}</i>
                                            </p>
                                            <b-form-select
                                                id="group-create-parent-select"
                                                v-model="questions.parent.value"
                                                :options="questions.parent.parents"
                                                style="margin-top: 20px"
                                                @change="parentChange">
                                            </b-form-select>
                                        </div>

                                        <div v-if="questions.course.live">
                                            <label for="group-create-course-select">{{ $t('group.course') }}</label>
                                            <b-form-select
                                                id="group-create-course-select"
                                                v-model="questions.course.value"
                                                :options="questions.course.courses"
                                                style="margin-top: 20px"></b-form-select>
                                            <b-form-invalid-feedback :state="this.valid">
                                                {{ $t('group.choose_course_before_you_go_further') }}
                                            </b-form-invalid-feedback>
                                        </div>

                                        <div v-if="questions.season.live">
                                            <label for="group-create-season-select">{{
                                                $t('group.school_year')
                                            }}</label>
                                            <b-form-select
                                                id="group-create-season-select"
                                                v-model="questions.season.value"
                                                :options="questions.season.seasons"
                                                style="margin-top: 20px"></b-form-select>
                                            <b-form-invalid-feedback :state="this.valid">
                                                {{ $t('group.choose_school_year_before_you_go_further') }}
                                            </b-form-invalid-feedback>
                                        </div>

                                        <div v-if="questions.start.live">
                                            <label>{{ $t('group.start_date') }}</label>
                                            <b-form-datepicker
                                                class="apprentice-date-picker btn-date-group"
                                                id="group-create-start-datepicker"
                                                v-model="questions.start.value"
                                                menu-class="datedropdown"
                                                start-weekday="1"
                                                now-button
                                                reset-button
                                                right
                                                today-variant="primary"
                                                nav-button-variant="primary"
                                                locale="nl"
                                                :aria-controls="$t('group.choose_date')"
                                                label-reset-button="reset"
                                                :label-no-date-selected="$t('group.no_date_selected')"
                                                :date-format-options="{
                                                    year: 'numeric',
                                                    month: 'short',
                                                    day: '2-digit',
                                                    weekday: 'short',
                                                }"></b-form-datepicker>

                                            <b-form-group :label="$t('group.start_time')">
                                                {{ $t('group.from_this_date_the_project_will_be_shown_to_students') }}.
                                                <design-2021-apprentice-timepicker-component
                                                    v-model="
                                                        questions.startTime
                                                    "></design-2021-apprentice-timepicker-component>
                                            </b-form-group>

                                            <b-form-invalid-feedback :state="this.valid">
                                                {{ $t('group.choose_start_date_before_you_go_further') }}
                                            </b-form-invalid-feedback>
                                        </div>

                                        <div v-if="questions.end.live">
                                            <label>{{ $t('group.end_date') }}</label>
                                            <b-form-datepicker
                                                class="apprentice-date-picker btn-date-group"
                                                id="group-create-end-datepicker"
                                                v-model="questions.end.value"
                                                menu-class="datedropdown"
                                                start-weekday="1"
                                                now-button
                                                reset-button
                                                right
                                                today-variant="primary"
                                                nav-button-variant="primary"
                                                locale="nl"
                                                :aria-controls="$t('group.choose_date')"
                                                label-reset-button="reset"
                                                :label-no-date-selected="$t('group.no_date_selected')"
                                                :date-format-options="{
                                                    year: 'numeric',
                                                    month: 'short',
                                                    day: '2-digit',
                                                    weekday: 'short',
                                                }"></b-form-datepicker>
                                            <b-form-invalid-feedback :state="this.valid">
                                                {{ $t('group.choose_start_date_before_you_go_further') }}
                                            </b-form-invalid-feedback>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    name: 'design-2021-group-create-tab-general-component',
    props: ['courses', 'groups', 'seasons'],
    data() {
        const self = this;
        return {
            valid: true,
            firstQuestion: 'name',
            secondQuestion: 'parent',
            questions: {
                name: {
                    live: false,
                    value: '',
                    passed: false,
                    activate() {
                        this.live = true;
                        this.passed = false;
                    },
                    next() {
                        this.live = false;
                        this.passed = true;
                        return 'parent';
                    },
                    previous() {
                        return false;
                    },
                    valid() {
                        return this.value;
                    },
                },
                parent: {
                    live: false,
                    value: null,
                    passed: false,
                    parents: this.getGroupOptions(),
                    activate() {
                        this.live = true;
                        this.passed = false;
                        if (this.value) {
                            self.$emit('enable-finish');
                        }
                    },
                    next() {
                        if (this.value) {
                            return false;
                        }

                        this.live = false;
                        this.passed = true;
                        return 'course';
                    },
                    previous() {
                        this.live = false;
                        self.$emit('disable-finish');
                        return 'name';
                    },
                    valid() {
                        return true;
                    },
                },
                course: {
                    live: false,
                    value: null,
                    passed: false,
                    courses: this.getCourseOptions(),
                    activate() {
                        this.live = true;
                        this.passed = false;
                    },
                    next() {
                        this.live = false;
                        this.passed = true;
                        return 'season';
                    },
                    previous() {
                        this.live = false;
                        return 'parent';
                    },
                    valid() {
                        return this.value;
                    },
                },
                season: {
                    live: false,
                    value: null,
                    passed: false,
                    seasons: this.getSeasonOptions(),
                    activate() {
                        this.live = true;
                        this.passed = false;
                    },
                    next() {
                        this.live = false;
                        this.passed = true;
                        return 'start';
                    },
                    previous() {
                        this.live = false;
                        return 'course';
                    },
                    valid() {
                        return this.value;
                    },
                },
                start: {
                    live: false,
                    value: null,
                    passed: false,
                    activate() {
                        this.live = true;
                        this.passed = false;
                    },
                    next() {
                        this.live = false;
                        this.passed = true;
                        return 'end';
                    },
                    previous() {
                        this.live = false;
                        return 'season';
                    },
                    valid() {
                        return this.value;
                    },
                },
                startTime: null,
                end: {
                    live: false,
                    value: null,
                    passed: false,
                    activate() {
                        this.live = true;
                        this.passed = false;
                    },
                    next() {
                        return false;
                    },
                    previous() {
                        this.live = false;
                        return 'start';
                    },
                    valid() {
                        return this.value;
                    },
                },
            },
            currentQuestion: null,
        };
    },
    computed: {
        selectedName() {
            return this.questions.name.value;
        },
        selectedParent() {
            for (const parent of this.questions.parent.parents) {
                if (parent.value === this.questions.parent.value) {
                    return parent;
                }
            }
        },
        selectedCourse() {
            for (const course of this.questions.course.courses) {
                if (course.value === this.questions.course.value) {
                    return course;
                }
            }
        },
        selectedSeason() {
            for (const season of this.questions.season.seasons) {
                if (season.value === this.questions.season.value) {
                    return season;
                }
            }
        },
        selectedStart() {
            return this.questions.start.value;
        },
        selectedEnd() {
            return this.questions.end.value;
        },
    },
    methods: {
        next() {
            if (!this.currentQuestion.valid()) {
                this.valid = false;
                return false;
            } else {
                this.valid = true;
            }

            const nextQuestion = this.currentQuestion.next();

            if (nextQuestion) {
                if (nextQuestion === this.secondQuestion) {
                    this.$emit('enable-prev');
                }
                this.currentQuestion = this.questions[nextQuestion];
                this.currentQuestion.activate();
                return false;
            } else {
                let startDateTime = this.selectedStart;
                if (this.questions.startTime) {
                    startDateTime = this.selectedStart + ' ' + this.questions.startTime;
                }

                return {
                    name: this.selectedName,
                    parent: this.selectedParent,
                    course: this.selectedCourse,
                    season: this.selectedSeason,
                    start: startDateTime,
                    end: this.selectedEnd,
                };
            }
        },
        previous() {
            const previousQuestion = this.currentQuestion.previous();
            if (previousQuestion) {
                if (previousQuestion === this.firstQuestion) {
                    this.$emit('disable-prev');
                }
                this.currentQuestion = this.questions[previousQuestion];
                this.valid = true;
                this.currentQuestion.activate();
            }
            return false;
        },
        getGroupOptions() {
            let array = [{ value: null, text: this.$t('group.select_group') }];

            for (const group of this.groups) {
                array.push({
                    value: group.id,
                    text: group.name + ' (' + group.id + ')',
                });
            }

            return array;
        },
        getCourseOptions() {
            let array = [{ value: null, text: this.$t('group.select_course') }];

            for (const course of this.courses) {
                array.push({
                    value: course.id,
                    text: course.name,
                });
            }

            return array;
        },
        getSeasonOptions() {
            let array = [];

            for (const season of this.seasons) {
                array.push({
                    value: season.id,
                    text: season.season,
                });
            }

            return array;
        },
        parentChange(value) {
            if (value) {
                this.$emit('enable-finish');
            } else {
                this.$emit('disable-finish');
            }
        },
    },
    mounted() {
        this.currentQuestion = this.questions[this.firstQuestion];
        this.currentQuestion.activate();
    },
    created() {
        // check which season should be default
        const today = moment();
        for (const season of this.seasons) {
            const start = moment(season.start);
            const difference = start.diff(today, 'days');
            // 60 days in advance we will set next year as default
            if (this.questions && difference < 60) {
                this.questions.season.value = season.id;
                break;
            }
        }
    },
};
</script>

<style scoped lang="scss">
.no-border {
    border: 0px;
}

.general-form ::v-deep {
    .input.form-control {
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
    }
}

.school-section,
.dates {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: baseline;

    > div {
        flex: 1;

        &:not(:last-child) {
            margin-right: $grid-gutter-width;
        }
    }
}
</style>
